'use strict';

module.exports = function getPolyfill() {
	// Detect if an implementation exists
	// Detect early implementations which skipped holes in sparse arrays
	var implemented = Array.prototype.findIndex && ([, 1].findIndex(function (item, idx) {
		return idx === 0;
	}) === 0);


	return implemented ? Array.prototype.findIndex : require('./implementation');
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/array.prototype.findindex/polyfill.js
// module id = 20
// module chunks = 0